export default __webpack_public_path__ + "src/img/logo.svg";